import { Store } from "@ngxs/store";

import * as API from "@hiptraveler/data-access/api";
import { UserAction, UserState } from "@hiptraveler/data-access/user";
import { brandCampaignId, isWidget } from "@hiptraveler/common";

export interface WidgetResponse extends API.AddItineraryWidgetResponse {}

export function addUserItineraryByAddItineraryResponse(store: Store, response: API.AddItineraryResponse | API.AddItineraryBoardResponse, numDays?: number): void {

  const itineraries = store.selectSnapshot(UserState.itineraries) || [];
  const value = response?.data?.itiMap;
  const basicInfo = response?.data?.itiMap?.basicInfo;

  const data = isWidget() ? {
    id: value?.id || value?.basicInfo?.id || '',
    pageTitle: value?.pageTitle || basicInfo?.pageTitle || '',
    isAutoGenerated: value?.isAutoGenerated || basicInfo?.isAutoGenerated || true,
    itiDays: Array(numDays || 0).fill(true)
  } : {
    id: basicInfo?.id || '',
    pageTitle: basicInfo?.pageTitle || '',
    itiDays: Array(numDays || 0).fill(true)
  };

  const itineraryData: API.UserItineraryData = {
    ...data,
    campgnReference: brandCampaignId(),
    datePublished: new Date().getTime(),
    isPackagedTour: false,
    isPublic: false,
    title: value?.title || basicInfo?.title
  };
  itineraries.unshift(itineraryData);
  store.dispatch(new UserAction.UpdateItineraryData(itineraries));
}
